interface TagBadgeProps {
  tag: string;
  onClick?: () => void;
  onRemove?: () => void;
}

export function TagBadge({ tag, onClick, onRemove }: TagBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-3 py-1 bg-blue-100 text-blue-800 rounded text-sm ${onClick ? 'cursor-pointer hover:bg-blue-200' : ''}`}
      onClick={onClick}
    >
      {tag}
      {onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="ml-2 text-blue-600 hover:text-blue-900"
        >
          ×
        </button>
      )}
    </span>
  );
}
